import { useSidenavContext } from '@app/components/layout/sidenav/SidenavContext';
import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { VersionUpdateSidebarButton } from '@app/core/version-check/VersionUpdateSidebarButton';
import { UserRole } from '@mi-front/core';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { Box, IconButton, ListItem, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { NavItem } from '../link/NavItem';

const sidebarIconButtonSx = {
  color: '#e9ecef',
  '&:hover': {
    background: '#0a1d46',
    color: 'white',
  },
};

export function UserActions() {
  const { user } = useAuth();
  const { collapsed } = useSidenavContext();
  const intl = useIntl();

  if (collapsed) {
    return (
      <NavItem to="/logout" icon={<LogoutOutlinedIcon />}>
        {intl.formatMessage({
          id: 'core.sidenav.logoutBtnText',
          defaultMessage: 'Cerrar sesión',
        })}
      </NavItem>
    );
  }

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '0.25rem 0.75rem',
          gap: 1.5,
        }}
      >
        {user.role !== UserRole.SUPERADMIN && (
          <Tooltip
            title={
              <FormattedMessage
                id="core.sidenav.settingsBtnText"
                defaultMessage="Configuración de usuario"
              />
            }
            placement="top"
          >
            <IconButton component={Link} to="/settings/user" sx={sidebarIconButtonSx}>
              <ManageAccountsOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip
          title={
            <FormattedMessage id="core.sidenav.logoutBtnText" defaultMessage="Cerrar sesión" />
          }
          placement="top"
        >
          <IconButton component={Link} to="/logout" sx={sidebarIconButtonSx}>
            <LogoutOutlinedIcon />
          </IconButton>
        </Tooltip>
        <VersionUpdateSidebarButton />
      </Box>
    </ListItem>
  );
}
